import * as React from "react";
import { Link } from "gatsby";

import Layout from "../../components/Layout";
import Seo from "../../components/Seo";

import Old2005BlogPage from "../../components/Old2005BlogPage";

const OldBlogPage = () => (
  <Layout>
    <Seo title="Old 2005 Blog—August 2005" />
	<Old2005BlogPage>
		<h2>August 2005</h2>






		<h3 className="blogdate">
		Thursday, August 25, 2005
		</h3>






		<h4 className="blogitemtitle">
		Monday night at Lugger Bar
		</h4>





			<div className="blogitembody">
			Just a quick note to say I am performing 5:30 to 8:30 pm, Monday August 29, at Lugger Bar, which is at the Mercure Inn Continental (Weld Street, Broome).  You are all invited!  It is a cruisy coctail lounge with excellent acoustics, so I will be performing from a comfy sofa, unplugged and unamplified!  Stop in, have a drink and say hello!
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 7:41 PM &nbsp;

			</div>






		<h3 className="blogdate">
		Tuesday, August 23, 2005
		</h3>






		<h4 className="blogitemtitle">
		Broome Bum
		</h4>





			<div className="blogitembody">
			Broome is so cruisy and relaxing! I've been here nearly one month and have enjoyed every day - the first sight of clouds came only yesterday! I often swim in the emerald green water of Roebuck Bay in the mornings, hoping that salt water crocodiles are not nearby! I play guitar during the days, sometimes busking in China Town and meeting new friends. A great place to watch sunset is the famous Cable Beach, and afterwards we often make music on the beach, under the stars or the moon, while people fire twirl!<br /><br />A few nights ago I watched the Staircase to the Moon - very impressive! The tide goes completely out of Roebuck Bay and the moon appears as a glowing red orb, while the pools in the sand reflect the light - it appears as if you can climb to the moon! Search the internet for "Broome" and "staircase" and "moon" if you'd like to see it.  There is a night market when this occurs, and it seems like Broome comes alive for this event!<br /><br />I haven't been yet, however there is an ancient movie theatre in China Town, possibly built in 1916, that has an open roof so that you sit under the stars/moon while enjoying your movie!  And planes fly low overhead as the airport is nearby!  There are rustic old film projectors on display as if at a museum. <br /><br />I recommend staying at the MCG (campground) in Broome as there are so many people coming and going - there is no excuse for not meeting new people!  I know the facilities are not great, but deal with it.  My tent is under a mango tree, I haven't been hit by any fallen mangos however we did crack open a fallen coconut!<br /><br />Although Cable Beach isn't the best place for it, I have done some more surfing!  I even cut my foot up on some rocks!  The best part about Broome, and Western Australia, is how under populated it is.  There is so much space!  I am told that the east coast of Australia is saturated and commercial, and I will see some of it eventually... but I say choose WA while the getting is good!
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 7:32 PM &nbsp;

			</div>








		<p>
			<Link to="/blog2005/">Go back to the blog index page</Link>
		</p>
</Old2005BlogPage>
  </Layout>
)

export default OldBlogPage;
